module.exports = __webpack_public_path__ + "img/paypal.ebc3a88e.svg";